<tk-admin-menu />
<main class="content">
	<router-outlet />
</main>
